<template>
    <div class="flex max-w-30rem w-full">
        <form @submit.prevent="handleSubmit(!v$.$invalid)" class="flex flex-column w-full p-fluid">
            
            <!--EMAIL-->
            <div class="field mt-2 mb-2">
                <span class="text-color-secondary">{{ fields[lang].email }}:</span>
                <div class="p-float-label p-input-icon-right">
                    <IconField iconPosition="right">
                        <InputText id="email" v-model="v$.remail.$model" aria-describedby="email-error"
                            :class="{'p-invalid':v$.remail.$invalid && submitted, 'p-inputtext-lg': true, 'mt-2': true, 'mb-2': true, 'w-full': true, 'border-2': true, 'border-round-lg': true}"/>
                        <InputIcon class="pi pi-at"/>
                    </IconField>
                </div>
                <span v-if="v$.remail.$error && submitted">
                    <span id="email-error" v-for="(error, index) of v$.remail.$errors" :key="index">
                    <small class="p-error">{{error.$message}}</small>
                    </span>
                </span>
                <small v-else-if="(v$.remail.$invalid && submitted) || v$.remail.$pending.$response" class="p-error">{{v$.remail.required.$message.replace('Value', 'Email')}}</small>
            </div>
            
            
            <div class="field mt-2 mb-2">
                <span class="text-color-secondary">{{ fields[lang].phone_number }}:</span>
                <div class="p-inputgroup w-full mt-2 mb-2 phone_drop flex flex-row">

                    <!--COUNTRIES-->
                    <span class="p-inputgroup-addon p-0 border-y-2 border-left-2 border-right-none surface-border flex">
                        <Dropdown v-model="selectedCountry" :options="countries" filter optionLabel="name" :placeholder="fields[lang].country"
                            class="border-none w-8rem p-inputtext-lg flex">
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex h-full max-w-6rem align-items-center">
                                    <img :alt="slotProps.value.label" src="/images/flags/flag_placeholder.png" :class="`mr-2 flag flag-${slotProps.value.code.toLowerCase()}`" style="width: 18px" />
                                    <div>{{ slotProps.value.first }}</div>
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>
                            <template #option="slotProps">
                                <div class="flex max-w-6rem align-items-center">
                                    <img :alt="slotProps.option.label" src="/images/flags/flag_placeholder.png" :class="`mr-2 flag flag-${slotProps.option.code.toLowerCase()}`" style="width: 18px" />
                                    <div>{{ slotProps.option.name }} {{ slotProps.option.first }}</div>
                                </div>
                            </template>
                        </Dropdown>
                    </span>

                    <!--PHONE-->
                    <div class="p-inputgroup-addon flex flex-1 p-0 border-none">
                        <IconField iconPosition="right" class="w-full">
                            
                        
                            <InputText v-if="phone_mask_arr.length>1" input-id="phone_number" v-model="phone_number" :placeholder="get_mask(phone_mask_arr[0])" aria-labelledby="phone" aria-describedby="phone-help"
                                :class="{'p-invalid':v$.phone_number.$invalid && submitted, 'border-green-200': phone_is_valid,  'border-red-400': phone_number && phone_number.length>0 && !phone_is_valid}" 
                                class="w-full p-inputtext-lg border-2 border-round-right-lg border-noround-left"/>

                            <InputMask v-else input-id="phone_number" v-model="phone_number" :mask="get_mask(phone_mask_arr[0])" :placeholder="get_mask(phone_mask_arr[0])"
                                :class="{'p-invalid':v$.phone_number.$invalid && submitted, 'border-green-200': phone_is_valid, 'border-red-400': phone_number && phone_number.length>0 && !phone_is_valid}" 
                                class="w-full p-inputtext-lg border-2 border-round-right-lg border-noround-left"/>

                            <InputIcon v-if="!phone_number" class="pi pi-phone"/>
                            <InputIcon v-else class="pi pi-times pr-2 cursor-pointer" @click="clear_phone()"/>

                        </IconField>
                    </div>
                </div>
                <small v-if="!phone_is_valid && submitted" class="p-error">Phone is not valid</small>
            </div>

            <!--CHECK -->
            <div class="field mt-2 mb-2">
                <div class="field-checkbox">
                    <Checkbox id="accept" name="accept" value="Accept" v-model="v$.accept.$model" :class="{'p-invalid':v$.accept.$invalid && submitted}" />
                    <label for="accept" :class="{'p-error': v$.accept.$invalid && submitted}" class="text-sm">
                        {{ agreement[lang].agree }}<span class="cursor-pointer text-primary" @click="displayTerms = true">{{ agreement[lang].terms }}</span>,
                        <span class="cursor-pointer text-primary" @click="displayPolicy = true">{{ agreement[lang].policy }}</span> {{ agreement[lang].and }}
                        <span class="cursor-pointer text-primary" @click="displayAml = true">{{ agreement[lang].aml }}</span>
                    </label>
                </div>
            </div>
            
            <Button type="submit" :label="buttons[lang].registation" class="mt-2 p-button-lg w-full border-round-lg" :loading="isLoading" :disabled="isLoading" />
        </form>
    </div>

    <!--Terms-->
    <Dialog class="w-full border-none" modal 
        v-model:visible="displayTerms" style="max-width: 1200px;"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <span class="text-lg font-medium">{{ agreement[lang].termsTitle }}</span>
        </template>

        <Terms />

    </Dialog>

    <!--Policy-->
    <Dialog class="w-full border-none" modal 
        v-model:visible="displayPolicy" style="max-width: 1200px;"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <span class="text-lg font-medium">{{ agreement[lang].policyTitle }}</span>
        </template>

        <Policy />
    </Dialog>

    <!--AML-->
    <Dialog class="w-full border-none" modal 
        v-model:visible="displayAml" style="max-width: 1200px;"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <span class="text-lg font-medium">{{ agreement[lang].amlTitle }}</span>
        </template>

        <Aml />
    </Dialog>
</template>


<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Event from '@/assets/js/Event'
import { useVuelidate } from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import { mapActions } from "vuex"
import Terms from   '@/components/public/Terms.vue' 
import Policy from  '@/components/public/Policy.vue'
import Aml    from '@/components/public/Aml.vue' 
import { useCookies } from "vue3-cookies"

export default {
    props: ['redirect_url'],
    data() {
        return {
            fields:  {
                en:{
                    name: "Name",
                    email: "Email", 
                    login : "Login",
                    country: "Select a Country",
                    phone_number: "Phone number", 
                    or: "or",
                },
                ru:{
                    name: "Имя",
                    email: "Email", 
                    country: "Выберите страну",
                    phone_number: "Номер телефона",  
                    login : "Логин",
                    or: "или",                  
                }                 
            },
            agreement : {
                en:{
                    agree: "I agree with the ",
                    terms: "terms of service",
                    policy: "privacy policy",
                    aml: "AML/KYC policy",
                    and: "and",
                    termsTitle: "Terms of Service",
                    policyTitle: "Privacy Policy",
                    amlTitle: "AML/KYC Policy",
                },
                ru:{
                    agree:"Я согласен с ",
                    terms: "публичной офертой",
                    policy: "политикой конфиденциальности",
                    aml: "AML/KYC политикой",
                    and: "и",
                    termsTitle: "Публичная оферта",
                    policyTitle: "Политика конфиденциальности",
                    amlTitle: "AML/KYC Политика",
                },
            },
            buttons:  {
                en:{
                    sign_in : "Sign In",
                    registation: "Registration",
                    forgot_password: "Forgot password",
                },
                ru:{
                    sign_in : "Войти",
                    registation: "Регистрация",
                    forgot_password: "Забыл пароль",
                }                 
            },
            messages: {
                en: {
                    success_title: "Success",
                    success_subtitle: "Successful registration",
                    error_title: "registration error",
                },
                ru: {
                    success_title: "Успех",
                    success_subtitle: "Вы успешно зарегистрованы",
                    error_title: "Ошибка регистрации",
                }
            },
            remail: null,
            phone_number: null,
            accept: null,
            error: false,
            submitted: false,
            showMessage: false,
            isLoading: false,
            v$: useVuelidate(),
            visible: false,
            selectedCountry: { code: "RU", first: "+7", flag: "https://cdn.kcak11.com/CountryFlags/countries/ru.svg", mask: "(###)###-##-##", name: "Russian Federation" },
            countries: [
                { code: "RU", first: "+7", flag: "https://cdn.kcak11.com/CountryFlags/countries/ru.svg", mask: "(###)###-##-##", name: "Russian Federation" },
            ],
            phone_mask_arr: ['+9(999)999-99-99'],
            phone_is_valid: false,
            prefix: '+7',
            cookies: useCookies(),
            displayTerms: false,
            displayPolicy: false,
            displayAml: false,
        }
    },
    components:{
        Terms,
        Policy,
        Aml,
    },
    validations() {
        return {
            remail: {
                required, email
            },
            phone_number: {
                required
            },
            accept: {
                required
            }
        }
    },
    watch: {
        remail:function(email){
            this.remail=email.toLowerCase()
        },
        phone_number: function(val){
            if(!val) return
            const phoneFormat = val.replace(/[^0-9]/g, '')

            // если масок нет, то валидируем по длине
            if(!this.phone_mask_arr || this.phone_mask_arr.length == 0){
                if(phoneFormat.length >= 11 && phoneFormat.length <= 18){
                    this.phone_is_valid = true
                } else {
                    this.phone_is_valid = false
                }
                return
            }
            // если маска одна, то валидируем по совпадению длины маски и значения
            if(this.phone_mask_arr.length == 1){
                const maskFormat = this.phone_mask_arr[0].replaceAll('\-', '').replaceAll('\(', '').replaceAll('\)', '').replaceAll('\ ', '')
                if(phoneFormat.length == maskFormat.length){
                    this.phone_is_valid = true
                } else {
                    this.phone_is_valid = false
                }
                return
            }else{
                // если масок несколько, то валидируем по совпадению длины маски и значения
                let minLength = 1000
                let maxLength = 0
                // находим самую длинную и короткую 
                for(let i=0; i<this.phone_mask_arr.length; i++){
                    let mask = this.phone_mask_arr[i]
                    let maskFormat = mask.replaceAll('\-', '').replaceAll('\(', '').replaceAll('\)', '').replaceAll('\ ', '')
                    if(maskFormat.length < minLength){
                        minLength = maskFormat.length
                    }
                    if(maskFormat.length > maxLength){
                        maxLength = maskFormat.length
                    }                    
                }
                if(phoneFormat.length >= minLength && phoneFormat.length <= maxLength){
                    this.phone_is_valid = true
                } else {
                    this.phone_is_valid = false
                }
            }
            return
        },
        selectedCountry(){
            try{
                if(this.selectedCountry.mask && this.selectedCountry.mask.length > 0) {
                    if(typeof(this.selectedCountry.mask)=='object'){
                        this.phone_mask_arr = this.selectedCountry.mask
                    }else{
                        this.phone_mask_arr = [this.selectedCountry.mask]
                    }
                }else{
                    this.phone_mask_arr = []
                }
            } catch (error) {
                console.log('error', error)
                this.phone_mask_arr = []
            }
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        clear_phone(){
            this.phone_is_valid = false
            this.phone_number = ''
        },
        get_mask(val){
            return val.replaceAll('\#', '9')
        },
        ...mapActions(["ActionRegStep"]),
        async handleSubmit(isFormValid) {
            this.submitted = true;
            this.isLoading = true
            if (!isFormValid) {
                this.isLoading = false
                return;
            }

            this.event.send('regDo')

            const phone_number = this.phone_number.replace(/\D+/g,"")
            const prefix_format = this.prefix.replace(/\D+/g,"")

            // читаем store, cookie, localstorage на наличие UTM меток
            const utm_store = this.$store.getters.StateUtm
            const utm_cookie = this.cookies.cookies.get("utm")
            const utm_localstorage = JSON.parse(localStorage.getItem('utm'))
            const utm = this.helper.get_utm_from_meta(utm_store, utm_cookie, utm_localstorage)

            // читаем store, cookie, localstorage на наличие REF меток
            const ref_store = this.$store.getters.StateRef
            const ref_cookie = this.cookies.cookies.get("ref")
            const ref_localstorage = localStorage.getItem('ref')
            const ref = this.helper.get_ref_from_meta(ref_store, ref_cookie, ref_localstorage)
            
            try {
                const reg_data = {
                    email: this.remail,
                    phone: phone_number,
                    prefix: prefix_format,
                    country: this.selectedCountry.code,
                    ref: ref,
                    utm: utm
                }

                const reg = await this.ActionRegStep(reg_data).then(res=>res) 
                if(reg.result && reg.data) {
                    this.showMess('success', this.messages[this.lang].success_title, this.messages[this.lang].success_subtitle) 
                    this.event.send('regSuccess')
                    if(this.redirect_url) {
                        this.$router.push({path: this.redirect_url, query: {hash: reg.data.restore_hash, login: reg.data.login}})
                    } else {
                        this.$router.push({path: '/reg/fill/', query: {hash: reg.data.restore_hash, login: reg.data.login}})
                    }
                    this.isLoading = false
                    this.submitted = false
                } else {
                    this.isLoading = false
                    this.submitted = false
                    if(reg.errors) {
                        for (let i = 0; i < reg.errors.length; i++) {
                            this.showMess('error', this.messages[this.lang].error_title,  reg.errors[i])
                        }
                    } else {
                        this.showMess('error', this.messages[this.lang].error_title,  'registration error')
                    }
                }
            } catch (error) {
                this.showMess('error', 'Error', 'registration error')
                this.isLoading = false
                this.submitted = false
            } 
        },
        resetForm() {
            this.name = '';
            this.remail = '';
            this.password = '';
            this.phone_number = '';
            this.accept = null;
            this.error = null;
            this.submitted = false;
            this.showMessage = false;
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    mounted() {},
    async beforeCreate () {
        this.connect = new Connect(this)
        this.helper = new Helper()
        this.event = new Event()
        try{
            const countries = await this.connect.get_countries().then(res=>res)
            if(countries.result) {
                this.countries = countries.data
                for (let i = 0; i < this.countries.length; i++) {
                    const country = this.countries[i];
                    if(country.name=='Russian Federation'){
                        this.selectedCountry = country
                        break
                    }
                }
            }
        } catch (error) {
            console.log('error', error)
        }
    },
}
</script>